<template>
  <div class="d-block pt-12">
    <v-expansion-panels
      id="faq-container"
      multiple
      focusable
      tile
    >
      <template v-if="customFAQ && customFAQ.length">
        <faq-section
          v-for="(section, index) in customFAQ"
          :key="index"
          :header="section.header"
          :response="section.body"
        />
      </template>
      <template v-else>
        <faq-section
          v-for="item in [
            '01',
            '02',
            '03',
            '04',
            '05',
            '06',
            '07',
            '08',
            '09',
            '10',
            '11',
            '12',
            '13'
          ]"
          :key="`faq${item}`"
          :header="$t(`faq${item}-header`)"
          :response="$t(`faq${item}-response`)"
          :index="`faq${item}`"
        />
      </template>
    </v-expansion-panels>
    <back-button />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  GET_REWARD_LINK,
  GET_REWARD_CUSTOMIZATION
} from '../../store/get-types'
import FAQSection from './FAQSection'
import BackButton from './BackButton'

export default {
  name: 'FAQ',
  components: {
    'faq-section': FAQSection,
    BackButton
  },
  computed: {
    ...mapGetters({
      rewardLink: GET_REWARD_LINK,
      rewardCustomization: GET_REWARD_CUSTOMIZATION
    }),
    customFAQ () {
      return this.rewardCustomization && this.rewardCustomization.details
        ? this.rewardCustomization.details.customFAQ
        : []
    }
  }
}
</script>
